import { createFileRoute } from '@tanstack/react-router'

import { MENU } from '@/constants/common/message.constants'

export const Route = createFileRoute(
  '/_protected/$tenantKey/_performance_managements/monthly-tour-reports'
)({
  meta: () => [{ title: MENU.MONTHLY_TOUR_REPORT }]
})
